import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import decoder from 'jwt-decode'
import { requireLogin, loadProfile } from './actions/avatar';
import { withRouter } from "react-router"

export default function(ComposedComponent) {
  class Authenticate extends React.Component {
    componentDidMount() {
      const jwt = window.localStorage.getItem('jwt')
      let params = new URLSearchParams(this.props.location.search);
      const forward = params.get("forward")

      if(jwt) {
        const userId = decoder(jwt).id
        this.props.loadProfile(userId).then((res) => {
          if(!res.data.payment_gateway_code)
            this.props.history.push('/register/complete')
          else if (forward && forward === "challenge")
            this.props.history.push('/dashboard/challenge')
          else if(res.data.user_intro === 0)
            this.props.history.push('/welcome')
        }).catch((err) => {
          if (forward && forward === "challenge")
            this.props.history.push('/login?forward=challenge');
          else
            this.props.history.push('/login');
        })
      } else {
        this.props.requireLogin('Login required');
        if (forward && forward === "challenge")
          this.props.history.push('/login?forward=challenge');
        else
          this.props.history.push('/login');
      }
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators({ requireLogin, loadProfile }, dispatch);
  }

  return withRouter(connect(null, mapDispatchToProps)(Authenticate));
}
